module.exports = __webpack_public_path__ + "static/media/iris_editor_large.8c18c49e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iris_editor_large.png
// module id = 388
// module chunks = 17